/**
 *  meta with whitelabel example:
 * { whitelabel: 'https://example.com/whitelabel.css',
 *  whitelabelV2: 'https://example.com/whitelabel.css'}
 */
export const injectCSS = function (customCssUrl) {
    const link = document.createElement('link');
    link.href = customCssUrl;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.id = 'whitelabel-css-element';
    link.media = 'screen,print';
    document.getElementsByTagName('head')[0].appendChild(link);
};

export const setupWhiteLabel = function (meta) {
    try {
        let accountSettings = meta || {};
        if (typeof meta === 'string') accountSettings = JSON.parse(accountSettings);

        if (accountSettings.whitelabelV2) {
            injectCSS(accountSettings.whitelabelV2);
        } else if (accountSettings.whitelabel) {
            injectCSS(accountSettings.whitelabel);
        }
    } catch (error) {
        console.error('WhiteLabel ERROR:', error);
    }
};